import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing a view for displaying categories and products in a datatable.
 * @extends JetView
 */
export default class recordTableCategoriesProductsView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                {
                    id: 'package', // Column ID
                    header: _('dav'), // Column header with localization
                    fillspace: 2, // Fill space proportion
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format for the column
                },
                {
                    id: 'maintainer', // Column ID
                    header: 'ID Usuario', // Column header
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type
                },
                {
                    id: 'architecture', // Column ID
                    header: 'Transacción ID', // Column header
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/GetCateriesProducts', // Data source URL
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        // Event listener for filtering categories and products
        this.on(this.app, 'categoriesProducts:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with constructed query
            );
        });

        // Event listener for loading data by user ID
        this.on(this.app, 'user:id', (Id) => {
            grid.load(grid.data.url + '?id=' + Id); // Load data for specific user ID
        });
    }
}

// FILE DOCUMENTED
